import React from 'react';
import PropTypes from 'prop-types';

const BlockedAdvertiserIdFormatter = (props) => {
    const column = props.column || {};
    const isPublisherLevel = column.isPublisherLevel;
    const blockedAdvertiserId = props.row.advertiserId;
    const supplySourceNameView = blockedAdvertiserId;
    const publisherNameView = (
            <span className='publisher-level-blocked-sales-account'>
                {blockedAdvertiserId}
            </span>
    );
    return (<div>
        {props.row.publishersSupplySourcesId === 0 && !isPublisherLevel ?
            publisherNameView :
            supplySourceNameView}
    </div>);
};

BlockedAdvertiserIdFormatter.propTypes = {
    row: PropTypes.object,
    column: PropTypes.object
};

export default BlockedAdvertiserIdFormatter;